import { useMemo } from 'react'
import moment from 'moment'

const useEventSessionDateGrouping = (sessionList) => {
   const [sessionDates, sessionsGroupedByDate] = useMemo(() => {
      const sessionDatesResult = []
      const sessionsGroupedByDateResult = sessionList.items.reduce((result, session) => {
         const dateKey = moment(session.startDateTimeISO8601).format('YYYY[-]MM[-]DD')
         if (!result[dateKey]) {
            result[dateKey] = []
            sessionDatesResult.push({
               dateKey,
               nameFull: moment(session.startDateTimeISO8601).format('MMMM D'),
               nameShort: moment(session.startDateTimeISO8601).format('MMM D')
            })
         }

         result[dateKey].push(session)
         return result
      }, {})

      return [sessionDatesResult, sessionsGroupedByDateResult]
   }, [sessionList])

   return [sessionDates, sessionsGroupedByDate]
}

export default useEventSessionDateGrouping
